import { HeroSection, Section, SectionSubtitle, SectionTitle } from '@web_opxp/components';
import { useTranslation } from '@web_opxp/features';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { SKELETON_CLASSNAME } from '../base/constants';
import RestoreConfirmationPopup from './components/RestoreConfirmationPopup';
import SubscriptionsList from './components/SubscriptionsList';
import TerminateConfirmationPopup from './components/TerminateConfirmationPopup';
import { getSubscriptionRestoreStatus } from './selectors';
import { ManageActions } from './slice';
import { ESubscriptionRestoreState } from './types';

export default function Manage() {
  const dispatch = useDispatch();
  const { language, t } = useTranslation();
  const skeletonClassname = language ? '' : SKELETON_CLASSNAME;

  const [terminateSubscriptionId, setTerminateSubscriptionId] = useState<number | string>(-1);
  const handleCloseConfirmation = () => setTerminateSubscriptionId(-1);
  const handleShowConfirmation = (subscriptionId: number | string) => setTerminateSubscriptionId(subscriptionId);
  const handleTerminateSubscription = () => {
    dispatch(ManageActions.terminateSubscriptionRequest(terminateSubscriptionId));
    setTerminateSubscriptionId(-1);
  };

  const restoreStatus = useSelector(getSubscriptionRestoreStatus);
  const confirmRestoreHandler = () => dispatch(ManageActions.restoreSubscriptionConfirm());
  return (
    <div data-testid="manage">
      <HeroSection lottie={'brain'} lottieAuto={true} lottieLoop={true}>
        <SectionTitle className={skeletonClassname}>{t('manage:Manage.Title')}</SectionTitle>
        <SectionSubtitle className={skeletonClassname}>{t('manage:Manage.Subtitle')}</SectionSubtitle>
      </HeroSection>
      <Section>
        <SubscriptionsList onTerminateSubscription={handleShowConfirmation} />
        <p className="orders-link">
          <Link data-testid="orders-link" to={'/orders'}>
            {t('manage:Orders.Title')}
          </Link>
        </p>
      </Section>
      <TerminateConfirmationPopup
        show={terminateSubscriptionId !== -1}
        onClose={handleCloseConfirmation}
        onConfirm={handleTerminateSubscription}
      />
      <RestoreConfirmationPopup
        show={restoreStatus === ESubscriptionRestoreState.Success}
        onClose={confirmRestoreHandler}
      />
    </div>
  );
}
